module.exports = __webpack_public_path__ + "cuddle.png?f9aefb58ef62d6476cff2201059cc2fc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cuddle.png
// module id = 183
// module chunks = 0